import Vue from "vue";
import VueRouter from "vue-router";

import Dashboard from "./components/Dashboard";
import Map from "./components/Map";
import FormList from "./components/FormList";
import FormBuilder from "./components/FormBuilder";
import FormEditBuilder from "./components/FormEditBuilder";
import FormAnswers from "./components/FormAnswers";
import AuthoritiesList from "./components/AuthoritiesList";
import MonitorsList from "./components/MonitorsList";
import PlacesList from "./components/PlacesList";
import Login from "./components/Login.vue";
import EventsList from "./components/EventsList";
import ComplaintsList from "./components/ComplaintsList";
import Reports from "./components/Reports";
import Config from "./components/Config";
import PasswordChange from "./components/PasswordChange";
import Privacy from "./components/Privacy";
import Support from "./components/Support";
import AlertList from "./components/AlertList";
import ProjectExplorer from "./components/ProjectExplorer";
import AdminExplorer from "./components/AdminExplorer";
import PageNotFound from "./components/PageNotFound";
import Requestdel from "./components/Requestdel";

Vue.use(VueRouter);

const routes = [{
        path: "/login",
        name: "login",
        component: Login
    },
    {
        path: "/reset_password",
        name: "reset_password",
        component: PasswordChange
    },
    {
        path: "/privacy",
        name: "privacy",
        component: Privacy
    },
    {
        path: "/requestdel",
        name: "requestdel",
        component: Requestdel
    },     
    {
        path: "/support",
        name: "support",
        component: Support
    },
    {
        path: "/explorador",
        name: 'explorer',
        component: ProjectExplorer
    },
    {
        path: "/panel",
        component: Dashboard,
        name: "dashboard",
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "/mapa",
                name: "mapa",
                component: Map,
                meta: {
                    requiresAuth: true
                }
            },
/*             {
                path: "/cuestionarios",
                component: FormList,
                meta: {
                    requiresAuth: true
                }
            },   */          
            {
                path: "/adminexplorer",
                component: AdminExplorer,
                meta: {
                    requiresAuth: true
                }
            },
/*             {
                path: "/cuestionarios/nuevo",
                component: FormBuilder,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/cuestionarios/editar/:id",
                component: FormEditBuilder,
                name: "editarCuestionario",
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/cuestionarios/respuestas/:id",
                component: FormAnswers,
                name: "respuestasCuestionario",
                meta: {
                    requiresAuth: true
                }
            }, */
            {
                path: "/monitores",
                component: AuthoritiesList,
                meta: {
                    requiresAuth: true,
                    permission: "admin"
                }
            },
            {
                path: "/gestores",
                component: MonitorsList,
                meta: {
                    requiresAuth: true,
                    permission: "admin"
                }
            },
            {
                path: "/registros",
                component: PlacesList,
                meta: {
                    /* permission: "admin", */
                    requiresAuth: true
                }
            },
/*             {
                path: "/eventos",
                component: EventsList,
                meta: {
                    permission: "admin",
                    requiresAuth: true
                }
            },
            {
                path: "/quejas",
                component: ComplaintsList,
                meta: {
                    requiresAuth: true
                }
            }, */
            {
                path: "/reportes",
                component: Reports,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "/administracion",
                component: Config,
                meta: {
                    permission: "admin",
                    requiresAuth: true
                }
            },
/*             {
                path: "/alertas",
                component: AlertList,
                meta: {
                    requiresAuth: true
                }
            }, */

        ]
    },
    {
        path: "/:pathMatch(.*)*",
        name: "page-not-found",
        component: PageNotFound
    }
];

const router = new VueRouter({ mode: "history", routes });

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth && !localStorage.getItem("accessToken")) {
        next({ name: "login", query: { next: to.path } });
    } else {
        if (to.fullPath == "/") {
            next({ name: "explorer" });
        } else {
            if (to.meta.permission == "admin" && localStorage.getItem("is_admin") == "false") {
                next({ name: "mapa" });
            } else {
                next();
            }
        }
    }
});

export default router;
